import type { FC, ReactNode } from 'react'

interface BootScreenProps {
    label?: string
    progress?: number
}

const BootScreen: FC<BootScreenProps> = ({ label = 'Warming up the engines', progress }): ReactNode => {
    const pct = typeof progress === 'number' ? Math.max(4, Math.min(100, Math.round(progress * 100))) : null

    return (
        <div className='fixed inset-0 z-50 flex flex-col items-center justify-center overflow-hidden bg-gradient-to-b from-sky-400 via-sky-300 to-emerald-300 px-6 text-center'>
            <div className='bg-checker absolute inset-x-0 top-0 h-6 opacity-90' aria-hidden='true' />
            <div className='bg-checker absolute inset-x-0 bottom-0 h-6 opacity-90' aria-hidden='true' />

            <p className='font-heading text-lg font-semibold tracking-[0.3em] text-indigo-950/80 uppercase'>
                Welcome to
            </p>

            <p className='font-heading text-outline mt-1 text-5xl leading-none font-bold text-white sm:text-7xl'>
                Phonics Grand Prix
            </p>

            <p className='font-heading mt-3 inline-block rounded-full bg-red-500 px-5 py-1 text-xl font-bold tracking-widest text-white shadow-[0_5px_0_#991b1b] sm:text-2xl'>
                CVC RACE
            </p>

            <div className='mt-10 w-full max-w-sm'>
                <div className='h-5 w-full overflow-hidden rounded-full border-4 border-white bg-indigo-950/30 shadow-lg'>
                    <div
                        className='h-full rounded-full bg-gradient-to-r from-amber-300 via-yellow-300 to-amber-400 transition-[width] duration-300'
                        style={{ width: pct === null ? '35%' : `${pct}%` }}
                    />
                </div>

                <p className='font-heading mt-3 text-lg font-semibold text-indigo-950'>
                    {label}
                </p>
            </div>
        </div>
    )
}

export default BootScreen
